import Translations from '../../components/Translations';
import React, {
    useState,
    useEffect,
} from 'react';
import {
    connect,
} from 'react-redux';
import {
    Container,
    Message,
} from 'semantic-ui-react';
import {
    useLocation,
} from 'react-router-dom';

import {
    // handleGetFamily,
    handleGetConfiguration,
} from '../../actions';
import LoadTimer from '../../components/loadtimer';

// A custom hook that builds on useLocation to parse
// the query string for you.
const useQuery = () => {
    return new URLSearchParams(useLocation().search);
}

const LoginPage = (props) => {

    const delegatedToken = useQuery().get('delegatedToken');
    const pageType = useQuery().get('pageType');
    const [error, setError] = useState(null);

    useEffect(() => {
        // console.log('component loaded ->', delegatedToken);
        (async () => {

            props.handleGetConfiguration(
                {
                    token: delegatedToken,
                    pageType: (pageType) ? pageType : 'selection',
                }, 
                (error) => {
                    setError(error);
                }
            );

            // Check if there is selection schedule using "delegatedToken"
            // const selection = await querySelectionSchedule({token: delegatedToken});
            // if (selection instanceof Error) {
            //     setError(selection);
            //     return null;
            // }
            // console.log('selection->', selection);
            // Load Family
            // props.handleGetFamily({token: delegatedToken}, (error) => {
            //     setError(error);
            // });
            // const family = await queryFamily({token: delegatedToken});
            // if (family instanceof Error) {
            //     setError(family);
            //     return null;
            // }
            // console.log('family->', family);
        })();

        // if (user && user.token) {
        //     history.replace('/app');
        // }
    }, [delegatedToken, props]);

    if (error) {
        return (
            <Container>
                <Message error><Translations text="selection.load_error" backup={"There was an issue loading your selection experience. Please try again later or contact us."} /></Message>
            </Container>
        );
    };

    return <LoadTimer />;

    // return (
    //     <Grid container centered stackable columns={1} padded="vertically">
    //         <Grid.Column>
    //             {/* <lottie-player
    //                 autoplay
    //                 loop
    //                 mode="normal"
    //                 speed={1}
    //                 src="https://assets6.lottiefiles.com/packages/lf20_mdbdc5l7.json"
    //             /> */}
    //         </Grid.Column>
    //         <Grid.Column>
    //             <LoadTimer />
    //         </Grid.Column>
    //     </Grid>
    // );
};

export default connect(null, {
    handleGetConfiguration,
})(LoginPage);

// driving caravan
// https://assets6.lottiefiles.com/packages/lf20_mdbdc5l7.json
// around the globe
// https://assets6.lottiefiles.com/datafiles/AtGF4p7zA8LpP2R/data.json
// paperplane
// https://assets2.lottiefiles.com/packages/lf20_x62chJ.json